export const pluralize = (count: number, suffix: string = 's'): string => {
    return count > 1 ? suffix : '';
};
